export enum PolicyType {
  MyHealth = "MyHealth",
  MyHome = "MyHome",
  Remote = "Remote",
}
